<div class="spacer">
  <p-panel>
    <div class="grid" *ngIf="this.updatedProperties?.length > 0">
      <div class="col-12">
        <p-header class="sub-section-header">Properties History</p-header>
      </div>
      <div class="newtable">
      <p-table *ngIf="this.updatedProperties?.length > 0" #alloProperty name="alloPropertiesTable"
        [value]="updatedProperties" [columns]="alloPropCols" [scrollable]="true" [resizableColumns]="true"
        sortMode="multiple" [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10, 20, 30, 40, 50]"
        class="data-table shrink-headers" scrollHeight="450px">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field">
              <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order">
              </p-sortIcon>
              {{ col.header }}
            </th>
          </tr>
          <tr class="column-filters">
            <th *ngFor="let col of columns" [ngSwitch]="col.field">
              <input *ngIf="col.field != Select" pInputText type="text"
                (input)="alloProperty.filter($event.target.value, col.field, 'contains')"
                (change)='filterCapture($event, alloProperty)'>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-alloProperty>
          <tr>
            <td>{{ alloProperty.domicile }}</td>
            <td>{{alloProperty.propType }}</td>
            <td>{{ alloProperty.propName }}</td>
            <td>{{ alloProperty.currentPropValue }}</td>
            <td>{{ alloProperty.createdBy }}</td>
            <td>{{ formatDate(alloProperty.createdDate) }}</td>
            <td>{{ alloProperty.updatedBy }}</td>
            <td>{{ formatDate(alloProperty.updatedDate) }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    </div>

    <div class="grid" *ngIf="this.userReportsHistory?.length > 0">
      <div class="col-12">
        <p-header class="sub-section-header">Reports History</p-header>
      </div>
      <div class="newusertable">
        <p-table *ngIf="this.userReportsHistory?.length > 0" #alloReportsHistory name="alloReportsHistoryTable"
          [value]="userReportsHistory" [columns]="alloReportCols" [scrollable]="true" [resizableColumns]="true"
          sortMode="multiple" [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10, 20, 30, 40, 50]"
          class="user-history-data-table shrink-headers" scrollHeight="800px">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns" [pSortableColumn]="col.field">
                <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                  ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order">
                </p-sortIcon>
                {{ col.header }}
              </th>
            </tr>
            <tr class="column-filters">
              <th *ngFor="let col of columns" [ngSwitch]="col.field">
                <input *ngIf="col.field != Select" pInputText type="text"
                  (input)="alloReportsHistory.filter($event.target.value, col.field, 'contains')"
                  (change)='filterCapture($event, alloReportsHistory)'>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-alloReportsHistory>
            <tr>
              <td>{{ alloReportsHistory.userName }}</td>
              <td>{{ alloReportsHistory.period }}</td>
              <td *ngIf="alloReportsHistory.namc != null && alloReportsHistory.namc != undefined && alloReportsHistory.namc != '' && alloReportsHistory.namc">
                {{ alloReportsHistory.namc }}</td>
              <td *ngIf="alloReportsHistory.domicile != null && alloReportsHistory.domicile != undefined && alloReportsHistory.domicile != '' && alloReportsHistory.domicile">
                {{ alloReportsHistory.domicile }}</td>
              <td *ngIf="(alloReportsHistory.namc == null && alloReportsHistory.domicile == null) || (alloReportsHistory.namc == '' && alloReportsHistory.domicile == '')
              || (!alloReportsHistory.namc && !alloReportsHistory.domicile)">
                {{ alloReportsHistory.namc }}</td>
              <td>{{ alloReportsHistory.reportName }}</td>
              <td>{{ alloReportsHistory.reportStatus }}</td>
              <td>{{ formatDate(alloReportsHistory.startDateTime) }}</td>
              <td>{{ formatDate(alloReportsHistory.endDateTime) }}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
      
    </div>

    <div class="grid">
      <div class="col-12 md:col-6 lg:col-2"></div>
      <div class="col-12 md:col-6 lg:col-8">
        <div *ngFor="let msg of errMsgs">
          <p-message [severity]="msg.severity" [text]="msg.summary" [closable]="true"></p-message>
        </div>
      </div>
      <div class="col-12 md:col-6 lg:col-2"></div>
    </div>
  </p-panel>
</div>